import styled from 'styled-components'
import { fontType, mediaQuery, toRem } from '../../styles/functions';
import InputMask from 'react-input-mask';
import { X, Check } from 'react-feather'

interface FormWrapperProps {
	isActive?: boolean;
  }

export const ContainerPaymentForm = styled.div`
  gap: 30px;
  display: flex;  
  flex-direction: row;
  justify-content: center;
  //align-items: start;
  padding: 60px 10px 60px 10px;
  flex-wrap: wrap;

//    ${mediaQuery('md')(`	
//    gap: 0;
// `)}
`

export const XButton = styled(X)`
	position: absolute;
	right: 7px;
  bottom: 9px;
	z-index: 5;
  cursor: pointer;
`

export const CheckButton = styled(Check)`
	position: absolute;
	right: 7px;
  bottom: 9px;
	z-index: 5;
  cursor: pointer;
`

export const FormWrapperCC = styled.div`
  //background: #24A4C4;
  // padding: 20px;
  border-radius: 10px;
  // margin-bottom: 20px;
  
   min-width: 466px;
   ${mediaQuery('md')(`	
   min-width: 0;
 `)}
`;

export const FormWrapperPix = styled.div`
  //background: #CCCCCC;
  // padding: 20px;
  border-radius: 10px;
  // margin-bottom: 20px;
  min-width: 466px;
  ${mediaQuery('md')(`	
  min-width: 0;
`)}
`;

export const FormHeaderCC = styled.div<FormWrapperProps>`
background: ${({ isActive }) => (isActive ? '#24A4C4' : '#CCCCCC')};
cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);

`;

export const FormHeaderPix = styled.div<FormWrapperProps>`
background: ${({ isActive }) => (isActive ? '#24A4C4' : '#CCCCCC')};
cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 20px;
  padding: 20px;
  border-radius: 10px;
  margin-bottom: 20px;box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;

export const IconContainer = styled.div`
  font-size: 24px;
  color: #fff;
`;

export const FormTitle = styled.h2`
  color: white;
  font-size: 24px;

  ${mediaQuery('xxxs')(`	
  font-size: ${toRem(19)};
`)}
`;

export const FormBodyCC = styled.form<any>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 20px;
  border-radius: 10px;
//   margin-bottom: ${props => (props.isOpen ? '0' : '0')};
   background: ${({ isActive }) => (isActive ? '#24A4C4' : '#CCCCCC')};
  overflow: hidden;
  transition: max-height 0.5s ease, opacity 0.5s ease, transform 0.5s ease;
  max-height: ${props => (props.isOpen ? '700px' : '0')};
  opacity: ${props => (props.isOpen ? '1' : '0')};
  transform: ${props => (props.isOpen ? 'scaleY(1)' : 'scaleY(0)')};
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  `;

export const FormBodyPix = styled.form<any>`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  padding: 20px;
  border-radius: 10px;
//   margin-bottom: 70px;
   background: ${({ isActive }) => (isActive ? '#24A4C4' : '#CCCCCC')};
  overflow: hidden;
  transition: max-height 0.5s ease, opacity 0.5s ease, transform 0.5s ease;
  max-height: ${props => (props.isOpen ? '500px' : '0')};
  opacity: ${props => (props.isOpen ? '1' : '0')};
  transform: ${props => (props.isOpen ? 'scaleY(1)' : 'scaleY(0)')};
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
`;



export const InputWrapper = styled.div`
  position: relative;
  width: 100%;
  //margin: 10px 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  color: #000;
`;

export const Input = styled.input<any>`
  background: white;
  padding: 10px;
  border-radius: 8px;
  border: 0;
  font-size: 18px;
  width: 100%;
  color: #000;
  ::placeholder{
    color: ${props => (props.isPix ? '#000' : '#CCCCCC')};
  }

  ${mediaQuery('xxs')(`	
  flex-wrap: nowrap;
`)}
`;

export const InputMasked = styled(InputMask)`
  background: white;
  padding: 10px;
  border-radius: 8px;
  border: 0;
  font-size: 18px;
  width: 100%;
  color: #000;
  ::placeholder{
    color: #CCCCCC;
  }
`;

export const ExtraText = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #24A4C4;
  font-weight: 500;
`;

export const HalfInputWrapper = styled.div`
  display: flex;
  gap: 10px;
  //width: 100%;

  ${mediaQuery('xxs')(`	
  flex-wrap: nowrap;
`)}
`;

export const HalfInput = styled(Input)`
  //flex: 1;
`;

export const SuccessMessage = styled.p`
	//position: absolute;
	//top: 56px;
  // margin-top: 0.5rem;
	font-size: ${toRem(16)};
	color: ${(props) => props.theme.COLORS.MID_GREY};
	text-transform: uppercase;
	${fontType(2)};
`

export const CouponSection = styled.div`
  background: #E0E0E0;
  //width: 366px;
  //height: 86px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: space-between;
  padding: 15px;
  gap: 4px;
  margin-top: 50px;
`;


export const InputVoucher = styled.input<any>`

position: relative;

background: ${props => (props.isCupomSet ? '#CCCCCC' : 'white')};
color: ${props => (props.isCupomSet ? '#CCCCCC' : '#000')};

${props => (props.isCupomSet ? 'pointer-events: none' : '')};  

  background: white;
  padding: 10px;
  border-radius: 8px;
  border: 0;
  font-size: 18px;
  width: 100%;
  //color: #000;
  ::placeholder{
    color: ${props => (props.isPix ? '#000' : '#CCCCCC')};
  }

  ${mediaQuery('xxs')(`	
  flex-wrap: nowrap;
`)}
`;


export const PaymentTextContainer = styled.div`
  display: flex;
  ${fontType(2)};
  font-size: ${toRem(58)};

  padding: 0 10px 0 10px;

  ${mediaQuery('sm')(`	
  	font-size: ${toRem(44)};
	`)}

  ${mediaQuery('xxs')(`	
	align-items: center;
   flex-direction: column;
`)}

`;

export const TextBlue = styled.span`
  color: #24A4C4;
  margin-right: 5px; 
  text-align: center;

${mediaQuery('sm')(`	
  	font-size: ${toRem(44)};
	`)}

	${mediaQuery('xxs')(`	
  	font-size: ${toRem(38)};
	`)}

	${mediaQuery('xxxs')(`	
  	font-size: ${toRem(34)};
	`)}
`;

export const TextBlack = styled.span`
  color: black;
  text-align: center;


  ${mediaQuery('sm')(`	
  font-size: ${toRem(44)};
`)}

${mediaQuery('xxs')(`	
  font-size: ${toRem(38)};
`)}

${mediaQuery('xxxs')(`	
  font-size: ${toRem(34)};
`)}
`;

export const TextBelow = styled.p`
text-align: center;
font-size: ${toRem(58)};

  ${fontType(2)};

  ${mediaQuery('sm')(`	
  font-size: ${toRem(44)};
`)}

${mediaQuery('xxs')(`	
  font-size: ${toRem(38)};
`)}

${mediaQuery('xxxs')(`	
  font-size: ${toRem(34)};
`)}
`;


export const ContentSummary = styled.div`
  min-height: 100vh;
	background: #24A4C4;

	display: flex;
	align-items: center;
	flex-direction: column;
	padding: 60px 100px 46px 100px;
	width: 100%;

	${mediaQuery('md')(`	
	padding: 53px 10px 26px 10px;
  `)}
`

export const ContainerSummary = styled.div`

	width: 100%;
	border-radius: 4px;
	display: flex;
	flex-direction: column;
	align-items: center;
	align-self: center;
	justify-content: center;
`
export const Title = styled.span`
	text-align: center;
	${fontType(1)};
	color: ${({ theme }) => theme.COLORS.BLACK};
	font-size: ${toRem(22)};
	margin-bottom: 16px;
`



export const SummarySlug = styled.h2`
	${fontType(2)};
	font-size: ${toRem(58)};
	font-weight: semibold;
	text-align: center;
	letter-spacing: -0.38px;
	color: ${({ theme }) => theme.COLORS.BLACK};
	max-width: 600px;
	margin-bottom: 48px;
	${mediaQuery('xxs')(`	
	font-size: ${toRem(48)};
  `)}
`

export const Content = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	//height: 100%;

	${mediaQuery('md')(`
		flex-direction: column;
		align-items: center;
		justify-content: center;
		padding: 0;
	`)};
`
export const Row = styled.div`
	display: flex;
	flex-direction: row;
	width: 100%;
	//height: 100%;
	justify-content: space-between;
	gap: 45px;
	margin-bottom: 12px;

	${mediaQuery('md')(`
		justify-content: space-between;
	`)};
`

const Section = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	//height: 100%;
`

export const SectionLeft = styled(Section)`
	text-align: left;
	justify-content: space-between;
	gap: 18px;
	width: 100%;
	position: relative;

	${mediaQuery('xxs')(`
		text-align: center;
	`)};

	${mediaQuery('md')(`
		margin-bottom: 16px
		gap: 0;
		justify-content: center;
		align-items: center 
	`)};
`

export const SectionRight = styled(Section)`
	text-align: right;
	justify-content: center;
	align-items: flex-end;
	width: 100%;

	${mediaQuery('xxs')(`
		align-items: center;
		text-align: center;
	`)};

	${mediaQuery('sm')(`
		width: 20%;
	`)};

	${mediaQuery('md')(`
		align-items: end;
		width: 100%;
		align-items: center;
	`)};
`

const Column = styled.div`
	//height: 100%;
	display: flex;
	flex-direction: column;
	align-items: start;

	${mediaQuery('md')(`
		align-items: center;
		margin-bottom: 16px
	`)};
`

export const LeftColumn = styled(Column)`
	padding: 30px;
	min-height: 70px;
	gap: 6px;
	align-items: start;

	${mediaQuery('md')(`
		align-items: center;
	`)};
`

export const RightColumn = styled(Column)``

export const PrimaryText = styled.span`
	${fontType(1)}
	color: ${({ theme }) => theme.COLORS.BLACK};
	font-weight: 500;
	font-size: ${toRem(28)};
	

	${mediaQuery('md')(`
	text-align: center;
	`)}

	${mediaQuery('md')(`
	font-size: ${toRem(24)};
	`)}
	
	${mediaQuery('xs')(`
	font-size: ${toRem(20)};
	`)}
`

export const SecondaryText = styled.span`
	${fontType(0)}
	color: ${({ theme }) => theme.COLORS.WHITE};
	font-size: ${toRem(28)};
	text-align: left;

	${mediaQuery('xxs')(`
		text-align: center;
	`)};

	${mediaQuery('sm')(`
		font-size: ${toRem(22)};
		text-align: start;
	`)}

	${mediaQuery('xs')(`
		font-size: ${toRem(20)};
		text-align: center;
	`)}

	${mediaQuery('md')(`
		text-align: center;
	`)}
`


export const ScreenCheckBox = styled.div`
	margin-bottom: 24px;
	${fontType(3)}
	color: ${({ theme }) => theme.COLORS.BLACK};
	font-size: ${toRem(28)};
`



export const TermsLinks = styled.div`
	position: relative;
	padding: 30px 0;
	width: 100%;
	height: 45px;
	display: table;
	text-align: center;
	font-weight: 400;
	font-size: 1.25rem;
	a {
		color: #000000;
	}
`


export const Tertiary = styled.span`
	${fontType(1)}
	color: ${({ theme }) => theme.COLORS.WHITE};
	font-size: ${toRem(28)};
	font-weight: 500;
	text-align: left;
	${mediaQuery('xs')(`
		font-size: ${toRem(20)};
		text-align: center;
	`)}
`


export const TotalContainer = styled.div`
	width: 255px;
	height: 40px;
	//background: ${({ theme }) => theme.COLORS.WHITE};
	border-radius: 5px;
	padding: 8px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
`

export const TotalText = styled.span`
	${fontType(3)}
	color: ${({ theme }) => theme.COLORS.BLACK};
	font-size: ${toRem(28)};
	text-align: right;

	letter-spacing: 0px;
	//color: #616161;
	opacity: 1;
	margin-top: 55px;

	${mediaQuery('xxs')(`
		text-align: center;
		margin-top: 0;
	`)};

	${mediaQuery('sm')(`
		font-size: ${toRem(24)};
	`)}

	${mediaQuery('xs')(`
	font-size: ${toRem(20)};
	`)}


	${mediaQuery('md')(`
	margin-top: 0;
	`)}
`

export const TotalValue = styled.span`
	${fontType(3)}
	color: ${({ theme }) => theme.COLORS.BLACK};
	font-size: ${toRem(28)};

	margin-top: 55px;
	
	${mediaQuery('xxs')(`
	margin-top: 0;
	`)};

	${mediaQuery('sm')(`
	font-size: ${toRem(24)};
	`)}

	${mediaQuery('xs')(`
	font-size: ${toRem(20)};
	`)}

	${mediaQuery('md')(`
	margin-top: 0;
	`)}
`


export const ErrorMessage = styled.p`
	//position: absolute;
	//top: -22px;
	font-size: ${toRem(20)};
	color: ${(props) => props.theme.COLORS.ORANGE_ERROR};
	text-transform: uppercase;
	${fontType(2)};
	${mediaQuery('xs')(`
	font-size: ${toRem(16)};
	`)}
`

export const Checkboxs = styled.div`
	width: 100%;
	padding: 20px 0;
	//display: flex;
	//flex-direction: column;
	//justify-self: center;
`